"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LevelSystem = void 0;
const gotti_1 = require("gotti");
const Constants_1 = require("../../../Shared/Constants");
const CAMERA_OFFSET_X = 3;
const CAMERA_OFFSET_Y = 20;
const LOG_EVERY = 1000;
class LevelSystem extends gotti_1.ClientSystem {
    constructor() {
        super(Constants_1.SYSTEMS.LEVEL);
    }
    onClear() {
    }
    onLocalMessage(message) {
        switch (message.type) {
            case Constants_1.MESSAGES.CLIENT_PLAYER_ENTITY_INITIALIZED:
                this.clientPositionComponent = this.globals.clientPlayer.getComponent(Constants_1.SYSTEMS.POSITION);
                this.globals.tileWorld.bindCameraCenter(this.clientPositionComponent.getPosition(), { x: CAMERA_OFFSET_X, y: CAMERA_OFFSET_Y });
                setTimeout(() => {
                    this.globals.fadeIn();
                }, 100);
                break;
        }
    }
    onServerMessage(message) { }
    onStart() { }
    onEntityAddedComponent(entity, component) { }
    onEntityRemovedComponent(entity, component) { }
    update(delta) {
        var _a;
        if (((_a = this.globals.tileWorld.loadedMap) === null || _a === void 0 ? void 0 : _a.initialized) && !this.globals.tileWorld.isLoading) {
            this.globals.tileWorld.update(delta);
        }
    }
    onPeerMessage(peerId, message) { }
}
exports.LevelSystem = LevelSystem;
//# sourceMappingURL=module.js.map